export default __webpack_public_path__ + "img/3b92f3079beecefca3a43a6029671b8e.svg";